<article class="card border">
  <div class="card-body p-3">
    <div class="row">
      <div class="col-sm-6">
        @if (result.highlights.industry) {
          <h5>
            Industry:
            <span [innerHTML]="result.highlights.industry"></span>
          </h5>
        }
        @for (
          category of result.highlights.categories;
          track category;
          let i = $index
        ) {
          <div [ngClass]="'indent-' + i">
            <span [innerHTML]="category.name"></span> &rsaquo;
          </div>
        }
        <div class="mb-2" [ngClass]="'indent-' + result.categories.length">
          <span [innerHTML]="result.highlights.asset"></span>
        </div>
        @if (result.effectiveDate) {
          <div class="text-sm">
            Applies from: {{ result.effectiveDate | aadate }}
          </div>
        }
      </div>
      <div class="col-sm-6">
        @if (result.life || rates.length) {
          <article>
            <hr class="d-sm-none" />

            <app-depreciation-lookup-search-item-select
              [rates]="rates"
              [result]="result"
              (selectAlternate)="onSelect()"
            ></app-depreciation-lookup-search-item-select>
          </article>
        }

        @for (alternate of result.alternates; track alternate) {
          <article>
            <hr />

            <h6>
              {{ alternate.label }}
            </h6>

            <app-depreciation-lookup-search-item-select
              [rates]="rates"
              [result]="alternate"
              (selectAlternate)="onSelect(alternate)"
            ></app-depreciation-lookup-search-item-select>
          </article>
        }
      </div>
    </div>
  </div>
</article>
